import 'whatwg-fetch';

let endpoint = process.env['REACT_APP_BSL_APP_URL_' + process.env.REACT_APP_ENV.toUpperCase()];

function postToServer (url, body, callback) {
  // console.log(JSON.stringify(body));
  fetch(url, {
    method: 'post',
    body: JSON.stringify(body),
    headers: {
      'Accept': 'application/json',
      'Content-Type': 'application/json'
    }
  })
  .then((resp) => resp.json()) // Transform the data into json
  .then(function (data) {
    // console.log('data', data);
    callback(data);
  });
}

const fetchHelpers = {
  getPackage: function (body, callback) {
    // get from /signup/getpackage
    postToServer(endpoint + '/signup/getpackage', body, callback);
  },
  postToTransfer: function (body, callback) {
    // post to /signup/transfer
    postToServer(endpoint + '/signup/transfer', body, callback);
  },
  postToCheckout: function (body, callback) {
    // post to /signup/checkout
    postToServer(endpoint + '/signup/checkout', body, callback);

    /* -- for when there was a waiting list
    if (body.course.type === 'independent' ||
      body.course.title.indexOf('Level 1') > -1) {
      // post to /signup/stripe
      postToServer(endpoint + '/signup/stripe', body, callback);
    } else {
      // post to /signup/transfer
      postToServer(endpoint + '/signup/transfer', body, callback);
    } -- */

  },
  postToComplete: async function (orderId) {
    // post to /signup/complete
    const response = await fetch(endpoint + '/signup/complete?orderid=' + orderId, { method: 'POST'});
    return response.json();
  },
  postToFreeTrial: function (body, callback) {
    // post to /signup/freetrial
    postToServer(endpoint + '/signup/freetrial', body, callback);
  },
  postToPlan: function (body, callback) {
    // post to /signup/plan
    postToServer(endpoint + '/signup/plan', body, callback);
  },
  redirectToApp: function (token) {
    if (token && token !== '') {
      window.location = endpoint + '/Account/tokenLogin?token=' + token;
    }
  }
};

export default fetchHelpers;



// WEBPACK FOOTER //
// ./src/helpers/fetchHelpers.js